<template>
  <div class='pros-form-item pros-date-picker'/>
</template>

<script>
    import {DatePicker} from '@printos/agnostic-forms';

    export default {
    props: {
      id: {
        type: String,
      },
      label: {
        type: String,
      },
      modelValue: {
        type: Date,
      },
      min: {
        type: Date,
      },
      max: {
        type: Date,
      },
      placeholder: {
        type: String,
      },
      hint: {
        type: String,
      },
      required: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      clear: {
        type: Boolean,
        default: false,
      },
      format: {
        type: String,
      },
      display: {
        type: String,
      },
      theme: {
        type: String,
      },
      shape: {
        type: String,
      },
      density: {
        type: String,
      },
      errors: {
        type: Array,
      },
      validation: {
        type: Boolean,
        default: true,
      },
      valid: {
        type: Boolean,
        default: true,
      },
    },
    emits: ['update:modelValue', 'update:valid', 'changed'],
    watch: {
      id: function(newVal) {
        this._printos.text.$set({id: newVal});
      },
      display: function(newVal) {
        this._printos.datePicker.$set({display: newVal});
      },
      theme: function(newVal) {
        this._printos.datePicker.$set({theme: newVal});
      },
      shape: function(newVal) {
        this._printos.datePicker.$set({shape: newVal});
      },
      density: function(newVal) {
        this._printos.datePicker.$set({density: newVal});
      },
      modelValue: function(newVal) {
        this._printos.datePicker.$set({ value: newVal });
      },
      min: function(newVal) {
        this._printos.datePicker.$set({ min: newVal });
      },
      max: function(newVal) {
        this._printos.datePicker.$set({ max: newVal });
      },
      label: function(newVal) {
       this._printos.datePicker.$set({ label: newVal});
      },
      placeholder: function(newVal) {
       this._printos.datePicker.$set({ placeholder: newVal});
      },
      hint: function(newVal) {
       this._printos.datePicker.$set({ hint: newVal});
      },
      format: function(newVal) {
       this._printos.datePicker.$set({ format: newVal});
      },
      clear: function(newVal) {
       this._printos.datePicker.$set({ clear: newVal});
      },
      required: function(newVal) {
        this._printos.datePicker.$set({ required: newVal });
      },
      disabled: function(newVal) {
        this._printos.datePicker.$set({ disabled: newVal });
      },
      validation: function(newVal) {
       this._printos.datePicker.$set({ validation: newVal});
      },
      errors: function(newVal) {
       this._printos.datePicker.$set({ errors: newVal});
      },
    },
    mounted() {
      this._printos = {};
      this._printos.datePicker = new DatePicker({
        target: this.$el,
        props: {
          id: this.id,
          display: this.display,
          theme: this.theme,
          shape: this.shape,
          density: this.density,
          label: this.label,
          value: this.modelValue,
          min: this.min,
          max: this.max,
          placeholder: this.placeholder,
          hint: this.hint,
          required: this.required,
          disabled: this.disabled,
          clear: this.clear,
          format: this.format,
          errors: this.errors,
          validation: this.validation,
        },
      });

      this._printos.datePicker.$on('changed', event => {
        this.$emit('update:modelValue', event.detail);
        this.$emit('changed', event.detail);
      });

      this._printos.datePicker.$on('valid', event => {
        this.$emit('update:valid', event.detail);
      })
    },
    unmounted() {
      this._printos.datePicker.$destroy();
    },
  }
</script>

